import React, { Component } from 'react';

import './login.css';
import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Progress,
  Row,
  Col,Container,
  Form,
  FormGroup,
  FormFeedback,
  FormInput,
  FormSelect
} from "shards-react";

import {
    Redirect,
    Route
} from 'react-router-dom';
import _ from 'underscore';
import firebases from '../config';




var context=null;
class Login extends Component {
    
    constructor(prop){


        super();
        
        this.state= {
        redirectToReferrer: false,
        credentials:{
        email:"",
        password:"",
        phone:""},
        required:false,
        subs:[],
        error:false,
        errorMessage:"",
        isLogged:false
        
      }
     context = this;
  
    if(sessionStorage.getItem("isLogged")){

         this.setState({isLogged:true});
   
    }
    else{
      this.setState({isLogged:false});
    }

  this.handleChange = this.handleChange.bind(this);
       
   
    }


componentDidMount(){

  if(sessionStorage.getItem("isLogged")){

    this.setState({isLogged:true});

}

}




      handleChange(event){
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({[name]:value});
     

     
     
      }



loginSubmit =()=>{
    
    context.setState({error:false});

 

      firebases.auth().signInWithEmailAndPassword(context.state.email, context.state.password).then(function(u){
        
        sessionStorage.setItem("isLogged",true);
        window.location.reload();

}).catch(function(error) {
  // Handle Errors here.
   context.setState({error:true});
  var errorCode = error.code;
  var errorMessage = error.message;
     context.setState({errorMessage:errorMessage});

});


  
 
    }
   
   
    render() {
       
     
    const item = {};
  

        if(this.state.isLogged){
              return( <Redirect to={"/dashboard"} />);
        }

        return (
          <Container className="bg-full" fluid>
    <Row style={{paddingTop:'12%'}}>
     
      <Col
        className="main-content p-0"
      
        md={{ size: 4, offset: 4 }}
        
        tag="main"
      >
       <Card small className="mb-4 pt-3">
          <CardHeader className="border-bottom text-center">
            <div className="mb-3 mx-auto">
              <img
                className="rounded-circle"
                src={require("../images/logo.png")}
                alt={item.name}
                width="110"
              />
            </div>
            <h4 className="mb-0">Beyond Education Console</h4>
            <span className="text-muted d-block mb-2">Dashboard Login</span>
            <Col sm="12" md="12">
   
    <Form>
      <Row form>
        <Col md="12" className="form-group">
          <FormInput
            value={this.state.email}
            placeholder="Email"
            required
            {...this.state.error ?  'invalid' : 'valid'}
            name="email"
            onChange={this.handleChange}
          />
      
        </Col>
      
      </Row>
      <FormGroup>
        <FormInput  value={this.state.password}
            placeholder="Password"
            type="password"
            name="password"
            required
            {...this.state.error ?  'invalid' : 'valid'}
            onChange={this.handleChange}/>
        {this.state.error ? <FormFeedback invalid>{this.state.errorMessage}</FormFeedback> : ''}
      </FormGroup>
      {this.state.error ? <small style={{color:'red'}}>{this.state.errorMessage}</small> : ''}
    </Form>
  </Col>
            <Button pill  size="md" className="mb-2 mt-2 danger" onClick={this.loginSubmit}>
              <i className="material-icons mr-1">person_add</i> Login
            </Button> 
          </CardHeader>
          
        </Card>
      </Col>
    </Row>
  </Container>
          
        );
    }
}

export default Login;
